import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './par-type-kafalat.reducer'; // Assurez-vous que le chemin est correct

export const ParTypeKafalatDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const [loadModal, setLoadModal] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
    setLoadModal(true);
  }, [dispatch, props.match.params.id]);

  const parTypeKafalatEntity = useAppSelector(state => state.parTypeKafalat.entity);
  const updateSuccess = useAppSelector(state => state.parTypeKafalat.updateSuccess);

  const handleClose = () => {
    props.history.push('/par-type-kafalat');
  };

  useEffect(() => {
    if (updateSuccess && loadModal) {
      handleClose();
      setLoadModal(false);
    }
  }, [updateSuccess, loadModal, handleClose]);

  const confirmDelete = () => {
    dispatch(deleteEntity(parTypeKafalatEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="parTypeKafalatDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="almobadaraMasterDataApp.parTypeKafalat.delete.question">
        <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.delete.question" interpolate={{ id: parTypeKafalatEntity.id }}>
          Are you sure you want to delete this ParTypeKafalat?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-parTypeKafalat" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Archive</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ParTypeKafalatDeleteDialog;
